import mutations from './mutations';
import api from '../api';

export default {
  namespaced: true,
  state: {
    loading: false,
    costCategories: []
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    }
  },
  actions: {
    getAll({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.costCategory
        .getAll(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    create({ commit }, payload) {
      commit(mutations.LOADING);
      return api.costCategory
        .create(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    detail({ commit }, id) {
      commit(mutations.LOADING);
      return api.costCategory
        .detail(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    update({ commit }, { id, params }) {
      commit(mutations.LOADING);
      return api.costCategory
        .update(id, params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    delete({ commit }, id) {
      commit(mutations.LOADING);
      return api.costCategory
        .delete(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    }
  },
  getters: {
    isLoggedIn: state => state.isLoggedIn,
    isLoading: state => state.loading,
    error: state => {
      if (state.error && state.error.response) {
        return state.error.response.data;
      }
      return state.error;
    }
  }
};
